import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})

export class LeaderboardComponent implements OnInit {
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute
  ) {}

  data: any;
  score: number;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const groupId = Number(params['group_id']);
      const quarter = params['quarter'];

      this.dataService.getGameLeaderboard(quarter, groupId).then(res => {
        if (res) {
          const preprocessedData = res.map(team => {
            let score = 0;
    
            if (quarter === 'q4') {
              score = team.summary?.finalResult || 0;
            } else {
              score = (team.kpi?.registrations || 0) + (team.kpi?.k2l || 0);
            }
    
            return {
              ...team,
              score: score
            };
          });
    
          this.data = preprocessedData.sort((a, b) => {
            const nameA = (a.first_name + a.last_name).toLowerCase();
            const nameB = (b.first_name + b.last_name).toLowerCase();
            return nameA.localeCompare(nameB);
          });          
        }
      });
    });
  }
}